import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const Surface = () => {
  const { t, updateAddress, errors, surface } = useAddress()

  return (
    <SDFormControl plainLabel error={getError('surface', errors)}>
      <SDInput
        label={t('subscriptionTools:estimator.surface.label')}
        onBlur={surface => updateAddress({ surface })}
        currentValue={surface}
        endEnhancer='m2'
      />
    </SDFormControl>
  )
}

export default Surface
